import { useContext } from "react";
import { Session } from "../types/session";
import { SessionContext } from "../context/SessionContext";

export const useSession = (): Session => {
  return useContext(SessionContext);
};
